import React from 'react';

import background from './../UI/Intro.webp';

import { getProyecto, getDropboxFiles } from './../services/renders.dao';
import { ContextLoader } from './../utils/import.frames';

import LoadingScreen from './ingreso/loadingScreen.component';
import WelcomeScreen from './ingreso/welcomeScreen.component';
import Canvas from './canvas.component';

interface Ingreso {
	general: Array<String>;
	torre1: Array<String>;
	torre2: Array<String>;
	torre3: Array<String>;
	images: Array<String>;
}

interface Props {}

interface State {
	isLoading: boolean;
	proyecto: any;
	textures: any;
	gettingProjectInfo: boolean;
	errorGettingProjectInfo: boolean;
	downloadingImagesInfo: boolean;
	errorDowloadingImages: boolean;
	loadedImages: number;
	isWelcome: boolean;
	dissapearWelcome: boolean;
}

class Ingreso extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: true,
			proyecto: {},
			textures: {},
			gettingProjectInfo: true,
			errorGettingProjectInfo: false,
			downloadingImagesInfo: false,
			errorDowloadingImages: false,
			loadedImages: 0,
			isWelcome: false,
			dissapearWelcome: true,
		};
	}

	async componentDidMount() {
		try {
			this.setState(
				{
					proyecto: await getProyecto(),
				},
				async () => {
					try {
						const texts = await getDropboxFiles();
						var result = texts.data.files;
						var dicc: any = {};

						result.forEach((element: any) => {
							dicc[element.path] = element.link;
						});
						this.setState(
							{
								textures: dicc,
							},
							() => {
								this.setState(
									{
										gettingProjectInfo: false,
									},
									() => {
										this.setState({
											downloadingImagesInfo: true,
										});
										this.general = ContextLoader['General View']();
										this.torre1 = ContextLoader['Torre 1']();
										this.torre2 = ContextLoader['Torre 2']();
										this.torre3 = ContextLoader['Torre 3']();

										this.images = [
											this.general[0],
											this.general[6],
											this.general[12],
											this.general[18],
											this.general[24],
											this.general[30],
											this.general[36],
											this.general[42],
											this.general[48],
											this.general[54],
											this.general[60],
											this.general[66],
										];

										this.images.forEach((src: any) => {
											new Promise((resolve, reject) => {
												const img = new Image();
												img.src = src;

												img.onload = (event) => {
													this.setState(
														{
															loadedImages: this.state.loadedImages + 1,
														},
														() => {
															if (this.state.loadedImages === this.images.length) {
																this.setState({
																	downloadingImagesInfo: false,
																	isLoading: false,
																});
															}
														}
													);
												};
												img.onerror = (err) => {
													reject();
												};
											}).catch((e) => {
												this.setState(
													{
														errorDowloadingImages: true,
													},
													() => {
														console.log(e);
													}
												);
											});
										});
									}
								);
							}
						);
					} catch (err) {
						this.setState(
							{
								errorGettingProjectInfo: true,
							},
							() => {
								console.log(err);
							}
						);
					}
				}
			);
		} catch (err) {
			this.setState(
				{
					errorGettingProjectInfo: true,
				},
				() => {
					console.log(err);
				}
			);
		}
	}

	handleHideWelcomeScreen = () => {
		this.setState({
			isWelcome: true,
		});
		setTimeout(
			function (this: any) {
				this.setState({
					dissapearWelcome: false,
				});
			}.bind(this),
			700
		);
	};

	render(): React.ReactNode {
		return (
			<div className="ingreso-page">
				<img src={background} className="background-image" alt="" />
				<LoadingScreen
					isLoading={this.state.isLoading}
					gettingProjectInfo={this.state.gettingProjectInfo}
					errorGettingProjectInfo={this.state.errorGettingProjectInfo}
					downloadingImagesInfo={this.state.downloadingImagesInfo}
					errorDownloadingImages={this.state.errorDowloadingImages}
				/>
				{this.state.isLoading === false ? (
					<Canvas isWelcome={this.state.isWelcome} proyecto={this.state.proyecto.data} textures={this.state.textures} loadedImages={this.state.loadedImages} />
				) : null}
				{this.state.dissapearWelcome ? <WelcomeScreen isLoading={this.state.isLoading} isWelcome={this.state.isWelcome} handleHideWelcome={this.handleHideWelcomeScreen} /> : null}
			</div>
		);
	}
}

export default Ingreso;
